import { validateIsVisible } from '../permission';
import { PermissionSelectors } from '@copilot/common/store/selectors/permission';
import { useSelector } from 'react-redux';

export const useFeatureToggle = (name: string) => {
    const featureToggles = useSelector(PermissionSelectors.getPermissions);
    return validateIsVisible(featureToggles[name]);
};
